module.exports = __webpack_public_path__ + "static/media/27OCHA3.783d6646.jpg";